<template>
  <div class="user-his">
    <div style="padding:0 20px">
      <div class="user-his-detail">
        <div style="text-align: left;padding-top: 5px;padding-left: 5px;padding-bottom: 5px;">
          {{ user.startTime }} - {{ user.endTime }}
        </div>
        <div>
          <div>
            <div class="num">{{ user.integralTotal }}</div>
            <div>总学分</div>
          </div>
          <div>
            <div class="num">{{ user.integralDh }}</div>
            <div>兑换学分</div>
          </div>
          <div>
            <div class="num">{{ user.integral}}</div>
            <div>当年学分</div>
          </div>
        </div>
      </div>

      <div class="user-his-group">
        <router-link
          v-for="(item, index) in list"
          :key="index"
          class="user-his-list"
          :to="getCourseRoute(item)"
        >
          <div class="user-his-list-header">
            <div class="user-his-list-date">
              {{ item.startDate }} - {{ item.endDate }}
            </div>
            <div class="user-his-list-action">
              查看课程
              <van-icon name="arrow" />
            </div>
          </div>
          <div class="user-his-list-stats">
            <div>
              <div class="num">{{ item.integralTotal }}</div>
              <div>总学分</div>
            </div>
            <div>
              <div class="num">{{ item.integralDh }}</div>
              <div>兑换学分</div>
            </div>
            <div>
              <div class="num">{{ item.integral }}</div>
              <div>当年学分</div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="back-btn" @click="$router.back()">返回</div>
  </div>
</template>

<script>
import '@/assets/_variable.scss'
import {getHistory, getUserByPpn} from '@/api/user/index.js'
export default {
  name: 'HistoryList',
  data() {
    return {
      list: [],
      PPN: '',
      user: {
        integral: 0,
        integralTotal: 0,
        integralDh: 0,
      },
    }
  },
  created() {},
  methods: {
    getList() {
      getHistory({
        ppn: this.PPN,
      }).then((res) => {
        this.list = res.data;
      })
    },
    getUser() {
      getUserByPpn({
        ppn: this.PPN,
      }).then((res) => {
        this.user = res.data
      })
    },
    getCourseRoute(item) {
      return {
        path: '/historyCourseList',
        query: {
          startDate: item.startDate,
          endDate: item.endDate,
          integral: item.integral,
          integralTotal: item.integralTotal,
          integralDh: item.integralDh,
        },
      }
    },
  },
  mounted() {
    this.PPN = JSON.parse(localStorage.getItem('user')).ppn
    this.getUser();
    this.getList()
  },
}
</script>

<style lang="scss">
.history-list {
  padding: 20px;
}

.user-his {
  position: relative;
  width: 100%;
  padding: 20px 0 120px;
  height: 100vh;
  box-sizing: border-box;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background: url('../../assets/img/notice-bg.png') top center no-repeat;
  background-size: contain;

  .back-btn {
    z-index: 200;
    bottom: calc(24px + env(safe-area-inset-bottom, 0px));
  }

  &-detail {
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 78px;
    border-radius: 6px;
    background: linear-gradient(180deg, #737278 0%, #403f45 100%);
    margin-bottom: 10px;
    & > div {
      display: flex;
      justify-content: space-between;
      font-size: 11px;
      text-align: center;
      color: #fff;
    }
    & > div > div {
      padding: 0 30px;
      font-size: 11px;
      text-align: center;
      color: #fff;
      .num {
        font-family: 'Porsche Next Bold';
        font-size: 18px;
        font-weight: 700;
      }
    }
  }

  &-section {
    margin-bottom: 10px;

    &-title {
      font-size: 15px;
      font-weight: 500;
      color: #403f45;
    }

    &-tip {
      margin-top: 4px;
      font-size: 12px;
      color: #737278;
    }
  }

  &-group {
    background: transparent;
    margin-bottom: 10px;
  }

  &-list {
    display: block;
    padding: 12px 14px;
    margin-bottom: 10px;
    text-decoration: none;
    color: #403f45;
    cursor: pointer;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(64, 63, 69, 0.08);
    transition: background-color 0.2s, box-shadow 0.2s;

    &:hover {
      background-color: rgba(213, 0, 28, 0.04);
      box-shadow: 0 4px 12px rgba(64, 63, 69, 0.12);
    }

    &:active {
      background-color: rgba(213, 0, 28, 0.08);
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  &-list-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  &-list-date {
    font-size: 13px;
    font-weight: 500;
    color: #403f45;
  }

  &-list-action {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #d5001c;
    white-space: nowrap;

    .van-icon {
      margin-left: 2px;
      font-size: 14px;
    }
  }

  &-list-stats {
    display: flex;
    justify-content: space-between;
    padding-top: 8px;
    border-top: 1px solid rgba(218, 217, 222, 0.6);
    font-size: 11px;
    text-align: center;
    color: #403f45;

    & > div {
      flex: 1;
      padding: 0 6px;
      font-size: 11px;
      text-align: center;
      color: #403f45;

      .num {
        font-family: 'Porsche Next Bold';
        font-size: 18px;
        font-weight: 700;
      }
    }
  }
}
</style>
